/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

// Import the functions you need from the SDKs you need
import { Capacitor } from "@capacitor/core";
import { FirebaseApp, initializeApp } from "firebase/app";
import { getPerformance } from "firebase/performance";
import { getRemoteConfig, setCustomSignals } from "firebase/remote-config";

import packageJson from "../../../package.json";
import { log } from "../../util/log";

import config from "./firebase-web-config.json";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// Initialize Firebase

let firebaseApp: FirebaseApp;

if (Object.keys(config).includes("projectId")) {
  log("Firebase app has been setup");
  firebaseApp = initializeApp(config);

  if (!Capacitor.isNativePlatform()) {
    getPerformance(firebaseApp);

    const remoteConfig = getRemoteConfig(firebaseApp);
    setCustomSignals(remoteConfig, { web_app_version: packageJson.version }).catch((e) => log(e));
  }
}

export { firebaseApp };
